import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { TCPArea } from "./Styles";

export default function TCP({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="TCP"
            value={!value ? document.tcp.text : value}
          />
        </div>
      ) : (
        <TCPArea>
          <Informative
            readonly={true}
            label="TCP"
            value={!value ? document.tcp.text : value}
          />
        </TCPArea>
      )}
    </>
  );
}
